import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import PreviewIcon from '@material-ui/icons/Visibility';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import firebase from "firebase";
import CloseIcon from '@material-ui/icons/Close';
import ClearIcon from '@material-ui/icons/Cached';
import EjectIcon from '@material-ui/icons/Eject';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import CustomizedCampaignList from './CustomizedCampaignList'
import CheckedCircle from '@material-ui/icons/CheckCircle';
import HighlightOff from '@material-ui/icons/HighlightOff';
import CustomizedStationZoneTable from '../components/CustomizedStationZoneTable'
import { SubdirectoryArrowLeft } from '@material-ui/icons'
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, rows } = this.props;
    
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {rows.map(
            row => (
              <TableCell
                key={row.id}
                align={row.numeric ? 'right' : 'left'}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false }
              >
                <Tooltip
                  title="Sort"
                  disableTouchListener={row.sortable ? false : true }
                  disableFocusListener={row.sortable ? false : true }
                  disableHoverListener={row.sortable ? false : true }
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={(orderBy === row.id && row.sortable) ? true : false }
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            ),
            this,
          )}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes, onDeleteAllClick, movefile, onAddClick, onMoveAllClick } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          movefile ? <div style={{ display: 'flex', alignItems: 'center' }}>

            <Tooltip title="Move">
                <IconButton aria-label="Move" onClick={onMoveAllClick}>
                <SubdirectoryArrowLeft />
                </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
                <IconButton aria-label="Delete" onClick={onDeleteAllClick}>
                <DeleteIcon />
                </IconButton>
            </Tooltip> 
            </div> : 
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Move">
                <IconButton aria-label="Move" onClick={onMoveAllClick}>
                <SubdirectoryArrowLeft />
                </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
                <IconButton aria-label="Delete" onClick={onDeleteAllClick}>
                <DeleteIcon />
                </IconButton>
            </Tooltip> 
            </div>
        ) : (
          <Tooltip title="Add User" onClick={onAddClick}>
              <IconButton aria-label="Add">
              <AddIcon />
              </IconButton>
          </Tooltip> 
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
  },
  table: {
    width: '100%',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  actionButtons: {
    display: 'flex'
  },
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  AppBar: {
    boxShadow: 'none',
    borderBottom: '1px solid #e8e8e8',
  },
  tab: {
    borderLeft: '1px solid #e8e8e8',
  }
});

function TabContainer({ children, dir }) {
  return (
    <div dir={dir}>
      {children}
    </div>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

class EnhancedTable extends React.Component {

  state = {
    order: 'desc',
    orderBy: this.props.orderBy,
    selected: [],
    selectedId: '',
    page: 0,
    rowsPerPage: 5,
    openDialog: false,
    dialogTitle: 'No Title',
    folderId: '',
    folderName: '',
    dialogOption: '',
    selectedFileName: '',
    dialogFullscreen: false,
    value: 0,
    stationName: '',
    openSecondDialog: false,
    campaignData: [],
    selectedCampaign: null,
    selectedEditStation: null,
    zoneCollection:[],
    selectedZone: 'default',
    selectedTableCell: ''
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = event => {
    if (event.target.checked) {
      this.setState({ selected: this.props.data.map(n => n.id) })
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleToggle = (event, id) => { 

    if(id === this.state.selectedTableCell){
      this.setState({ selectedTableCell: ''})
    } else {
      this.setState({ selectedTableCell: id})
    }
    
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  bytesToSize = (bytes) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  };

  onEditClick = (id) => {

    const currentStationIndex = this.props.data.map((val)=>{ return val.id }).indexOf(id)

    const currentCampaignIndex = this.state.campaignData.map((val)=> { return val.id }).indexOf(this.props.data[currentStationIndex].campaign)

    this.setState({
      openDialog: true,
      dialogOption: 'edit',
      dialogTitle: "Edit Station",
      dialogFullscreen: false,
      selectedEditStation: this.props.data[currentStationIndex],
      stationName: this.props.data[currentStationIndex].name,
      selectedCampaign : this.state.campaignData[currentCampaignIndex]
    });
  }

  onDeleteClick = (id) => {
    this.setState({
        openDialog: true,
        dialogTitle: "Remove User",
        selectedId: id,
        dialogOption: 'delete',
        dialogFullscreen: false
    });
  }

  onPreviewClick = (id) => {

  }

  onDeleteAllClick = () => {
    this.setState({
        openDialog: true,
        dialogOption: 'deleteAll',
        dialogTitle: "Remove User",
        dialogFullscreen: false
    });
  }

  handleClose = () => {
    this.setState({ openDialog: false, selectedCampaign: null });
  };

  handleDialogClose = () => {
    this.setState({ openSecondDialog: false  });
  }

  handleSelectionChange = event => {
    this.setState({ selectedZone: event.target.value });
  };

  handleRemoveFile = () => {

    firebase.database().ref(this.props.dataName).child(this.state.selectedId).remove()

    this.setState({
      openDialog: false,
      selectedId: '',
      selected: []
    });
    
  }

  handleRemoveAllFile = () => {

    this.state.selected.forEach(items => {
        firebase.database().ref(this.props.dataName).child(items).remove()
    })

    this.setState({
      openDialog: false,
      selected: []
    });
  }

  renderDialog = () => {

    if(this.state.dialogOption === 'delete'){
        return(
            <div>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    Are you sure you want to permanently delete these user?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleRemoveFile} color="default">
                    Yes
                    </Button>
                    <Button color="primary" onClick={this.handleClose}>
                    No
                    </Button>
                </DialogActions>
            </div>
        )
    }

    else if(this.state.dialogOption === 'deleteAll'){
        return(
            <div>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    Are you sure you want to permanently delete these user?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleRemoveAllFile} color="default">
                    Yes
                    </Button>
                    <Button color="primary" onClick={this.handleClose}>
                    No
                    </Button>
                </DialogActions>
            </div>
        )
    } 

    else if(this.state.dialogOption === 'addUser'){
      return(
          <div style={{backgroundColor: '#f6f6f6'}}>
              <DialogContent >
                  <TextField
                    fullWidth
                    margin="dense"
                    id="standard-name"
                    label="Station Name"
                    value={this.state.stationName}
                    onChange={this.handleStationNameChange}
                  />
                  <Button style={{marginTop: 10}} fullWidth variant="outlined" color="primary" onClick={this.handleSelectCampaign}>
                    {this.state.selectedCampaign ? this.state.selectedCampaign.name : 'Select Campaign'}
                  </Button>
              </DialogContent>
              <DialogActions>
                  <Button onClick={this.handleAddStation} color="default">
                  Yes
                  </Button>
                  <Button color="primary" onClick={this.handleClose}>
                  No
                  </Button>
              </DialogActions>
          </div>
      )
    } 

    else if(this.state.dialogOption === 'edit'){

      return(
          <div style={{backgroundColor: '#f6f6f6'}}>
              <DialogContent >
                  <TextField
                    fullWidth
                    margin="dense"
                    id="standard-name"
                    label="Station Name"
                    value={this.state.stationName}
                    onChange={this.handleStationNameChange}
                  />
                  <Button style={{marginTop: 10}} fullWidth variant="outlined" color="primary" onClick={this.handleSelectCampaign}>
                    {this.state.selectedCampaign ? this.state.selectedCampaign.name : 'Select Campaign'}
                  </Button>
              </DialogContent>
              <DialogActions>
                  <Button onClick={this.handleEditStation} color="default">
                  Yes
                  </Button>
                  <Button color="primary" onClick={this.handleClose}>
                  No
                  </Button>
              </DialogActions>
          </div>
      )
    } else if(this.state.dialogOption === 'moveAll'){
      return(
          <div>
          <DialogContent style={{ width: 200}}>
              <FormControl style={{ marginTop: 20 }} fullWidth variant="outlined" noValidate autoComplete="off">
                  <InputLabel
                  ref={ref => {
                      this.InputLabelRef = ref;
                  }}
                  htmlFor="outlined-age-simple"
                  >
                  Zone
                  </InputLabel>
                  <Select
                  value={this.state.selectedZone}
                  onChange={this.handleSelectionChange}
                  input={
                      <OutlinedInput
                      labelWidth={100}
                      name="zone"
                      id="outlined-age-simple"
                      />
                  }
                  >
                  
                  <MenuItem value="default">
                      <em>Default</em>
                  </MenuItem>
                  {this.state.zoneCollection.map(n => {
                      return(
                      <MenuItem key={n.id} value={n.id}>{n.name}</MenuItem>
                      )
                  })}

                  </Select>
              </FormControl>
          </DialogContent>
          <DialogActions>
              <Button onClick={this.handleMoveAllFile} color="primary">
              Yes
              </Button>
              <Button onClick={this.handleClose} color="primary" autoFocus>
              No
              </Button>
          </DialogActions>
          </div>
      )
  }

  }

  handleMoveAllFile = () => {
    
    if(this.state.selectedZone !== 'default'){
      this.state.selected.forEach(items => {

        firebase.database().ref().child('/station/' + items).once('value', snapshot => {
            if(snapshot.val().zone != this.state.selectedZone){
              firebase.database().ref().child('/station/' + items).update({ zone: this.state.selectedZone });
  
              firebase.database().ref().child('/station_zone/' + this.state.selectedZone).child('total').transaction( total => {
                
                return total + 1;
              })
            }
        })
        
      })
    }

    this.setState({
        openDialog: false,
        selectedZone: 'default',
        selected: []
    });

  }

  handleSelectCampaign = () => {
    this.setState({ openSecondDialog: true});
  }

  handleStationNameChange = event => {
    this.setState({ stationName: event.target.value });
  };  

  handleAddStation = () => {

    var newPostKey = firebase.database().ref().child('station').push().key;

    var postData = {
      name: this.state.stationName == ''? newPostKey : this.state.stationName,
      created: firebase.database.ServerValue.TIMESTAMP,
      updated: firebase.database.ServerValue.TIMESTAMP,
      campaign: this.state.selectedCampaign ? this.state.selectedCampaign.id : null,
      connected: false,
      used: false,
      zone: 'default'
    };

    var updates = {};
    updates['/station/' + newPostKey] = postData;
  
    firebase.database().ref().update(updates);

    var pushData = {
      push: false,
      message: ''
    };

    var push_updates = {};
    push_updates['/push_station/' + newPostKey] = pushData;

    firebase.database().ref().update(push_updates);
    
    this.setState({ openDialog: false, selectedCampaign: null, stationName: '' });
  }

  onMoveAllClick = () => {
    this.setState({
        openDialog: true,
        dialogOption: 'moveAll',
        dialogTitle: "Move Station"
    });
  }

  handleEditStation = () => {

    var postData = {
      name: this.state.stationName == ''? this.state.selectedEditStation.id : this.state.stationName,
      created: this.state.selectedEditStation.created,
      updated: firebase.database.ServerValue.TIMESTAMP,
      campaign: this.state.selectedCampaign ? this.state.selectedCampaign.id : null,
      connected: this.state.selectedEditStation.connected,
      used: this.state.selectedEditStation.used,
      zone: 'default'
    };

    var updates = {};
    updates['/station/' + this.state.selectedEditStation.id] = postData;
  
    firebase.database().ref().update(updates);
    
    this.setState({ openDialog: false, selectedCampaign: null, stationName: '' });
  }

  handleTabsChange = (event, value) => {
    this.setState({ value });
  };

  handleTabsChangeIndex = index => {
    this.setState({ value: index });
  };

  onAddClick = () => {
    this.setState({
      openDialog: true,
      dialogOption: 'addUser',
      dialogTitle: "Add User",
      dialogFullscreen: false,
      selectedCampaign: null,
      stationName: ''
    });
  }

  onRefreshClick = (id) =>{
    firebase.database().ref('push_station/' + id ).update({ push : true, message: "push" })
  }

  onClearRefreshClick = (id) =>{
    this.setState({
      openDialog: true,
      dialogTitle: "Push & Clear Station",
      selectedId: id,
      dialogOption: 'clear',
      dialogFullscreen: false
    });
  }

  handleClearStation = () => {
    firebase.database().ref('push_station/' + this.state.selectedId ).update({ push : true, message: "clear_push" })

    this.setState({
      openDialog: false,
      selectedId: '',
      selected: []
    });
  }

  onResetClick = (id) =>{
    this.setState({
      openDialog: true,
      dialogTitle: "Reset Station",
      selectedId: id,
      dialogOption: 'reset',
      dialogFullscreen: false
    });
  }

  handleResetStation = () => {
    firebase.database().ref('push_station/' + this.state.selectedId ).update({ push : true, message: "reset" })

    this.setState({
      openDialog: false,
      selectedId: '',
      selected: []
    });
  }

  componentWillMount(){
    let ref = firebase.database().ref('campaign');

    ref.on('value', snapshot => {
      const campaignData = [];

      snapshot.forEach(childSnapshot => {
        const item = childSnapshot.val();
        item.key = childSnapshot.key;

        campaignData.push({ id:item.key, name: item.name, created: item.created, updated: item.updated, template: item.template, template_name: item.template_name });
        
      });

      this.setState({ campaignData });
    });

    let zoneRef = firebase.database().ref('station_zone');

    zoneRef.on('value', snapshot => {
      const zoneCollection = [];

      snapshot.forEach(childSnapshot => {
        const item = childSnapshot.val();
        item.key = childSnapshot.key;
        
        zoneCollection.push({ id:item.key, name: item.name, created: item.created, total: item.total });
        
      });

      this.setState({ zoneCollection });
    });
  }

  handleSelectedCampaign = id => {

    const currentIndex = this.state.campaignData.map(val => { return val.id}).indexOf(id)

    this.setState({ openSecondDialog: false,  selectedCampaign: this.state.campaignData[currentIndex]});
  }
  
  render() {
    const { classes, rows, data, theme } = this.props;
    const { order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
      <div className={classes.root}>
        <AppBar className={classes.AppBar} position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleTabsChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab className={classes.tab} disableRipple label="User" />
            <Tab className={classes.tab} disableRipple label="Group" />
          </Tabs>
        </AppBar>
        <Dialog
            onClose={this.handleDialogClose}
            aria-labelledby="customized-dialog-title"
            open={this.state.openSecondDialog}
            maxWidth='xl'
          >
          <DialogTitle id="customized-dialog-title" onClose={this.handleDialogClose}>
            Campaign List
          </DialogTitle> 
          <DialogContent >
            <CustomizedCampaignList 
              rows={[
                { id: 'name', numeric: false, disablePadding: false, label: 'Campaign Name', sortable: true },
                { id: 'template', numeric: false, disablePadding: false, label: 'Template', sortable: true },
              ]} 
              data={this.state.campaignData}
              orderBy={'created'}
              movefile={false}
              dataName='campaign'
              handleSelectedCampaign={this.handleSelectedCampaign}/>
          </DialogContent>
        </Dialog>
        <Dialog
            fullScreen={this.state.dialogFullscreen}
            onClose={this.handleClose}
            aria-labelledby="customized-dialog-title"
            open={this.state.openDialog}
            maxWidth='xl'
            TransitionComponent={Transition}
          >
          {this.state.dialogFullscreen ? 
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" color="inherit" className={classes.flex}>
                  {this.state.dialogTitle}
                </Typography>
                <Button color="inherit" onClick={this.handleClose}>
                  save
                </Button>
              </Toolbar> 
            </AppBar>: 
            <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
              {this.state.dialogTitle}
            </DialogTitle> 
          }
          {this.renderDialog()}
        </Dialog>
        {this.state.value === 0 && <TabContainer dir={theme.direction}>
            <EnhancedTableToolbar numSelected={selected.length} onDeleteAllClick={this.onDeleteAllClick} movefile={this.props.movefile} onAddClick={this.onAddClick} onMoveAllClick={this.onMoveAllClick} />
            <div className={classes.tableWrapper}>
              <Table className={classes.table} aria-labelledby="tableTitle">
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={this.handleSelectAllClick}
                  onRequestSort={this.handleRequestSort}
                  rowCount={data.length}
                  rows={rows}
                />
               
                <TableBody>
                  {stableSort(data, getSorting(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(n => {
                      const isSelected = this.isSelected(n.id);

                      let selectedCampaign = 'none'
                      const currentCampaignIndex = this.state.campaignData.map(val => { return val.id}).indexOf(n.campaign)
                      if(currentCampaignIndex !== -1){
                        selectedCampaign = this.state.campaignData[currentCampaignIndex].name
                      }

                      return (
                        
                        [<TableRow
                          hover
                          role="checkbox"
                          aria-checked={isSelected}
                          tabIndex={-1}
                          key={n.id}
                          selected={isSelected}
                        >
                          <TableCell onClick={event => this.handleClick(event, n.id)} padding="checkbox">
                            <Checkbox checked={isSelected} />
                          </TableCell>

                          <TableCell onClick={event => this.handleToggle(event, n.id)} align="left" padding="none">{n.name}</TableCell>
                          <TableCell onClick={event => this.handleToggle(event, n.id)} align="left" padding="default">{n.role}</TableCell>

                        </TableRow>, 
                        <TableRow style={{ display: this.state.selectedTableCell === n.id ? '': 'none', backgroundColor: '#f1f1f1'}}>
                          <TableCell style={{ fontWeight: '600'}} padding={'default'} colSpan={1}>Id</TableCell>
                          <TableCell padding={'none'} colSpan={11}>{n.id}</TableCell>
                        </TableRow>, 
                        <TableRow style={{ display: this.state.selectedTableCell === n.id ? '': 'none', backgroundColor: '#f1f1f1'}}>
                          <TableCell style={{ fontWeight: '600'}} padding={'default'} colSpan={1}>Email</TableCell>
                          <TableCell padding={'none'} colSpan={11}>{n.email}</TableCell>
                        </TableRow>,
                        <TableRow style={{ display: this.state.selectedTableCell === n.id ? '': 'none', backgroundColor: '#f1f1f1'}}>
                          <TableCell style={{ fontWeight: '600'}} padding={'default'} colSpan={1}>Created by</TableCell>
                          <TableCell padding={'none'} colSpan={11}>{new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(n.created)}</TableCell>
                        </TableRow>,
                        <TableRow style={{ display: this.state.selectedTableCell === n.id ? '': 'none', backgroundColor: '#f1f1f1'}}>
                          <TableCell style={{ fontWeight: '600'}} padding={'default'} colSpan={1}>Updated by</TableCell>
                          <TableCell padding={'none'} colSpan={11}>{new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(n.updated)}</TableCell>
                        </TableRow>,
                        <TableRow style={{ display: this.state.selectedTableCell === n.id ? '': 'none', backgroundColor: '#f1f1f1'}}>
                          <TableCell style={{ fontWeight: '600'}} padding={'default'} colSpan={1}>Phone</TableCell>
                          <TableCell padding={'none'} colSpan={11}>{n.phone}</TableCell>
                        </TableRow>,
                        <TableRow style={{ display: this.state.selectedTableCell === n.id ? '': 'none', backgroundColor: '#f1f1f1'}}>
                          <TableCell style={{ fontWeight: '600'}} padding={'default'} colSpan={1}>Group</TableCell>
                          <TableCell padding={'none'} colSpan={11}>{n.group}</TableCell>
                        </TableRow>,
                        <TableRow style={{ display: this.state.selectedTableCell === n.id ? '': 'none', backgroundColor: '#f1f1f1'}}>
                          <TableCell padding={'default'} colSpan={12}>
                            <div className={classes.actionButtons}>
                                <IconButton disabled onClick={() => this.onEditClick(n.id) }>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton disabled onClick={() => this.onDeleteClick(n.id) }>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>]
                      );
                      
                      
                    })}
                    
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 49 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
        </TabContainer> }
          {this.state.value === 1 && <TabContainer dir={theme.direction}>
              <CustomizedStationZoneTable 
                rows={[
                  { id: 'name', numeric: false, disablePadding: true, label: 'Zone Name', sortable: true },
                  { id: 'total', numeric: false, disablePadding: false, label: 'Total Station', sortable: true },
                ]} 
                data={this.state.zoneCollection}
                orderBy={'created'}
                zoneCollection={this.state.zoneCollection}
                movefile={false}
                dataName='station_zone'/>
            </TabContainer>}
        
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(EnhancedTable);